module.exports = __webpack_public_path__ + "static/media/home-vector-white.363ceab6.svg";